// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"ThankYouPage_mainWrapper__Te1ou","thankyouWrapper":"ThankYouPage_thankyouWrapper__2vENd","btnDone":"ThankYouPage_btnDone__2D_7T"};